// Change #100463 - every live licence (started, not ended) of one company, via
// the Super Admin licence search (developer only). Pages through at the
// search's maximum page size.

import { useCallback, useEffect, useState } from "react";
import { FetchAPI } from "../../../../helpers/APIdata/fetchAPI";
import { getLicensesSubscriptionListApi } from "../../../../helpers/fakebackend_helper";

const PAGE = 200;

// customer = true: the customer's own Billing > Subscriptions (read only),
// from /subscriptionlicence/list/company/active (same rows, product name in
// SubscriptionProduct_Name, mapped onto the admin field name).
export default function useCompanyLicences(companyId, tab = "active", customer = false) {
  const [licences, setLicences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    if (!companyId && !customer) return;
    setLoading(true);
    try {
      if (customer) {
        const res = await getLicensesSubscriptionListApi();
        if (Number(res?.status) !== 200) throw new Error(res?.message || "Could not load your subscriptions");
        setLicences(
          (res?.subscriptionlicence_list || []).map((l) => ({
            ...l,
            SubscriptionProduct_NamePrinted: l.SubscriptionProduct_NamePrinted || l.SubscriptionProduct_Name,
          }))
        );
        setError("");
        return;
      }
      let all = [];
      for (let page = 1; page <= 20; page += 1) {
        // eslint-disable-next-line no-await-in-loop
        const res = await FetchAPI("/subscriptionlicenceadmin/search", "POST", [
          { Tab: tab, Company_Id: Number(companyId), Page: page, PageSize: PAGE },
        ]);
        if (Number(res?.status) !== 200) {
          throw new Error(res?.message || "Could not load the licences");
        }
        const rows = res?.subscriptionlicence_list || [];
        all = all.concat(rows);
        if (rows.length < PAGE) break;
      }
      setLicences(all);
      setError("");
    } catch (e) {
      setLicences([]);
      setError(e?.message || "Could not load the licences");
    } finally {
      setLoading(false);
    }
  }, [companyId, tab, customer]);

  useEffect(() => {
    load();
  }, [load]);

  return { licences, loading, error, reload: load };
}
